// extracted by mini-css-extract-plugin
module.exports = {"container":"BuyNow_container__3GIKj","text":"BuyNow_text__1IIld","img":"BuyNow_img__1NWxa","button":"BuyNow_button__101i_","button_wrapper":"BuyNow_button_wrapper__sumRq"};